export { AppText } from './AppText'
export type { AppTextProps } from './AppText'
